export default __webpack_public_path__ + "static/media/molinera.3b069bb6.jpg";